import { Box, Button, ButtonGroup, Grid, Popper, alpha, darken, styled } from '@mui/material';

export const SplitButtonWrapper = styled(Grid)(() => ({
  flexShrink: 0
}));

export const SplitButtonGroup = styled(ButtonGroup)(({ theme, color }) => {
  const paletteColor = theme.palette[color].main;
  return {
    width: '100%',
    '& .MuiButton-root': {
      color: theme.palette.common.white,
      fontSize: '0.8rem',
      backgroundColor: paletteColor,
      boxShadow:
        '0 2px 2px 0 ' +
        alpha(paletteColor, 0.14) +
        ', 0 3px 1px -2px ' +
        alpha(paletteColor, 0.2) +
        ', 0 1px 5px 0 ' +
        alpha(paletteColor, 0.12),
      '&:hover,&:focus': {
        backgroundColor: darken(paletteColor, 0.1),
        boxShadow: '0 3px 6px -5px ' + alpha(paletteColor, 0.42) + ', 0 3px 6px 0px ' + alpha(paletteColor, 0.2)
      }
    },
    '& .Mui-disabled': {
      opacity: 0.65,
      backgroundColor: paletteColor
    }
  };
});

export const SplitButtonHandle = styled(Button)(() => ({
  '&.Mui-disabled': {
    pointerEvents: 'auto'
  }
}));

export const SplitButtonPopper = styled(Popper)(({ theme }) => ({
  zIndex: 10,
  marginTop: theme.spacing(0.5)
}));

export const SplitButtonPopperAction = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  fontSize: '1rem'
}));
